"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomSelect = void 0;
const react_1 = __importStar(require("react"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const ramda_1 = require("ramda");
const utils_1 = require("@rjsf/utils");
const validator_ajv8_1 = __importDefault(require("@rjsf/validator-ajv8"));
const helpers_1 = require("../helpers");
const useLabelTooltip_1 = require("../../useLabelTooltip");
const CustomSelect = (field) => {
    var _a, _b, _c, _d;
    const hasErrors = Boolean((_a = field.rawErrors) === null || _a === void 0 ? void 0 : _a.length);
    const label = (0, helpers_1.getLabel)(field);
    const ariaLabel = !(0, ramda_1.isEmpty)(field.label) && field.label;
    const uiOptions = (_c = (_b = field.uiSchema) === null || _b === void 0 ? void 0 : _b['ui:options']) !== null && _c !== void 0 ? _c : {};
    const labelTooltip = (0, useLabelTooltip_1.useLabelTooltip)(uiOptions === null || uiOptions === void 0 ? void 0 : uiOptions.labelTooltip);
    const isMulti = (0, utils_1.isMultiSelect)(validator_ajv8_1.default, field.schema);
    const options = (0, react_1.useMemo)(() => {
        var _a, _b;
        return (_b = (_a = field.options.enumOptions) === null || _a === void 0 ? void 0 : _a.map((option) => {
            var _a;
            return (Object.assign(Object.assign({}, option), { isDisabled: (_a = field.options.enumDisabled) === null || _a === void 0 ? void 0 : _a.includes(option.value) }));
        })) !== null && _b !== void 0 ? _b : [];
    }, [field.options.enumDisabled, field.options.enumOptions]);
    const selected = (0, react_1.useMemo)(() => !isMulti
        ? options.find(({ value }) => value === field.value || (typeof value === 'object' && (0, ramda_1.equals)(value, field.value)))
        : field.options.enumOptions.filter(({ value }) => field.value.includes(value)), [field.value, options]);
    (0, react_1.useEffect)(() => {
        // reset value for multi select
        if (isMulti) {
            const newValue = field.value.filter((value) => options.some((option) => value === option.value));
            if (newValue.length !== field.value.length) {
                field.onChange(newValue);
            }
        }
    }, [options, field.value]);
    (0, react_1.useEffect)(() => {
        // reset value for single select
        let timeout;
        if (!isMulti) {
            if (!selected && !!field.value) {
                // hack: it doesn't work without timeout in case with few selects on form for some reason
                timeout = setTimeout(() => {
                    field.onChange(undefined);
                });
            }
        }
        return () => clearTimeout(timeout);
    }, [selected, field.value]);
    return (react_1.default.createElement(wl_ui_kit_1.Select, Object.assign({}, uiOptions, { labelTooltip: labelTooltip, isClearable: !field.schema.required, ariaLabel: ariaLabel, label: label, onChange: (option) => {
            if (!Array.isArray(option)) {
                field.onChange(option === null || option === void 0 ? void 0 : option.value);
            }
            else {
                field.onChange(option.map((0, ramda_1.prop)('value')));
            }
        }, isMulti: isMulti, name: field.id, value: selected || null, options: options, 
        //@ts-ignore
        required: field.schema.required, placeholder: field.placeholder, hintType: hasErrors ? 'error' : undefined, hint: hasErrors ? (_d = field === null || field === void 0 ? void 0 : field.rawErrors) === null || _d === void 0 ? void 0 : _d[0] : '', disabled: field.disabled })));
};
exports.CustomSelect = CustomSelect;
//# sourceMappingURL=custom-select.js.map